



























































import {Component, Prop, Vue} from "vue-property-decorator";
import DetailLading from "@/modules/ladings/Detail/index.vue";
import DetailLadingPrint from "@/modules/ladings/Print/components/Detail.vue";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath} from "@/shared/services/helper/utils";
import LadingPrintBill from "@/modules/ladings/Print/Bill/index.vue";
import LadingPrintA6 from "@/modules/ladings/Print/LabelA6/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "PrintLading",
    components: {LadingPrintA6, LadingPrintBill, DetailLadingPrint, DetailLading}
})
export default class extends mixins(CommonMixin) {
    @Prop({required: true}) readonly ladingIds!: string;
    @Prop({required: false, default: ''}) readonly idPrint!: string;
    visible = false;
    visibleChooseBill = false;
    hideFee = true;

    printObj: Options = {
        id: `print-bill${this.idPrint}`,
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css?v=${process.env.VUE_APP_VERSION}`
    };

    printCustomerObj: Options = {
        id: `print-bill-customer${this.idPrint}`,
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css?v=${process.env.VUE_APP_VERSION}`
    };
    
    printA5Obj: Options = {
        id: `print-a5${this.idPrint}`,
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/printA5.css?v=${process.env.VUE_APP_VERSION}`
    };

    printA5CustomerObj: Options = {
        id: `print-a5-customer${this.idPrint}`,
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/printA5.css?v=${process.env.VUE_APP_VERSION}`
    };

    printA6Obj: Options = {
        id: `print-a6${this.idPrint}`,
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css?v=${process.env.VUE_APP_VERSION}`
    };

    showChoosePrintLading() {
        (this.$refs.btnShowChoosePrintLading as any).$el.click();
    }

    printBill() {
        this.$print(this.printObj);
    }

    printBillCustomer() {
        this.$print(this.printCustomerObj);
    }
    
    printA5() {
        this.$print(this.printA5Obj);
    }

    printA5Customer() {
        this.$print(this.printA5CustomerObj);
    }
    
    printA6() {
        this.$print(this.printA6Obj);
    }

    onChangeHideFee(e) {
        this.hideFee = e.target.checked;
    }
}
